/**
 * FilterCombobox — Shared searchable dropdown using Popover + Command.
 * Used in FiltersPanel, MapFiltersBar, and HeatmapTab.
 */
import React, { useState } from 'react';
import { ChevronDown, Check, X } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import {
  Command, CommandInput, CommandEmpty, CommandGroup, CommandItem, CommandList,
} from './ui/command';

export default function FilterCombobox({
  label,
  value,
  options,
  onChange,
  loading = false,
  placeholder = 'Seleccionar...',
  width = '260px',
}) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          data-testid={`filter-combobox-${label}`}
          className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-xs border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:border-gray-300 transition-colors"
        >
          <span className={`truncate ${value ? 'text-foreground' : 'text-muted-foreground'}`}>
            {value || placeholder}
          </span>
          <ChevronDown className="w-3.5 h-3.5 ml-2 flex-shrink-0 text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        style={{ width: 'var(--radix-popover-trigger-width, 260px)' }}
        className="p-0 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 shadow-xl z-[200]"
        align="start"
      >
        <Command>
          <CommandInput placeholder={`Buscar ${label}...`} className="text-xs" />
          <CommandList>
            <CommandEmpty className="py-4 text-xs text-center text-muted-foreground">
              {loading ? 'Cargando...' : 'Sin resultados'}
            </CommandEmpty>
            <CommandGroup>
              {value && (
                <CommandItem
                  onSelect={() => { onChange(''); setOpen(false); }}
                  className="text-xs text-muted-foreground"
                >
                  <X className="w-3 h-3 mr-1.5" /> Limpiar selección
                </CommandItem>
              )}
              {options.map(opt => (
                <CommandItem
                  key={opt}
                  value={opt}
                  onSelect={() => { onChange(opt); setOpen(false); }}
                  className="text-xs"
                >
                  <Check className={`w-3 h-3 mr-1.5 flex-shrink-0 ${value === opt ? 'opacity-100 text-primary' : 'opacity-0'}`} />
                  <span className="truncate">{opt}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
